import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buttonVariants, cn } from "@dosa/ui";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-primary-700">404</p>
      <h1 className="text-3xl font-semibold text-charcoal-900">{t("common.noResults")}</h1>
      <Link to="/" className={cn(buttonVariants())}>
        {t("nav.home")}
      </Link>
    </div>
  );
}
